import { generatePath } from "react-router";

import { LangCode } from "@/lib/gql/__generated__/graphql";
import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { NewOptionEditContainer } from "@/components/features/items/edit/option/standard/default/ui/new";

import { useGetNewOptionEditPageParams } from "./_hooks/use-get-option-edit-page-params";

export const NewOptionEditPageDefault = () => {
	const { hotelID, duplicateItemID } = useGetNewOptionEditPageParams();
	const activeLangCode = LangCode.Default;

	return (
		<PageMeta
			title={duplicateItemID ? "オプションの複製" : "オプションの作成"}
			url={generatePath(PATHS.HOTEL.ITEMS.OPTION.EDIT.NEW.OPTION.DEFAULT, { hotelID })}
		>
			<NewOptionEditContainer hotelID={hotelID} optionID={duplicateItemID} activeLangCode={activeLangCode} />
		</PageMeta>
	);
};

NewOptionEditPageDefault.displayName = "NewOptionEditPageDefault";
